import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { EditableInputDisplay } from "../../components/EditableComponents";

export const getUserColumns = (setEditMode, setParentValue) => {
  return [
    {
      size: 100,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Nome",
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"first_name"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.first_name}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
    },
    {
      size: 100,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"last_name"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.last_name}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Cognome",
    },
    {
      size: 100,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"username"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.username}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Username",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 5,
      enableColumnFilter: false,
      accessorFn: (row) => (row.is_deleted ? "false" : "true"), // "true" : "false"),
      Cell: ({ cell }) =>
        cell.getValue() === "true" ? (
          <DoneIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        ),
      header: "Attivo",
    },
  ];
};

export const getOrgColumns = (setEditMode, setParentValue) => {
  return [
    {
      size: 120,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"name"}
          setEditMode={setEditMode === row.original.id}
          initialValue={row.original.name}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Nome",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 5,
      accessorFn: (row) => (row.is_active ? "true" : "false"),
      enableColumnFilter: false,
      Cell: ({ cell }) =>
        cell.getValue() === "true" ? (
          <DoneIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        ),
      header: "Attiva",
    },
  ];
};
